import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const scoreTrainingLocalGameRoutes: Route[] = [
    {
        path: 'local-games/score-training',
        loadComponent: () =>
            import('./pages/score-training-new-game/score-training-new-game.component').then(
                (c) => c.ScoreTrainingNewGameComponent
            ),
    },
    {
        path: 'game/score-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/score-training-local-game-app/score-training-local-game-app.component').then(
                (m) => m.ScoreTrainingLocalGameAppComponent
            ),
    },
];

export const scoreTrainingVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/score-training',
        loadComponent: () =>
            import('./pages/score-training-new-game/score-training-new-game.component').then(
                (c) => c.ScoreTrainingNewGameComponent
            ),
    },
    {
        path: 'game/score-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/score-training-local-game-venue/score-training-local-game-venue.component').then(
                (m) => m.ScoreTrainingLocalGameVenueComponent
            ),
    },
];
